import labels from './labels.json';
import statuses from './statuses.json';
import chFaultsModal from './channel/faults-modal.json';
import tcFaultsModal from './thermocouple/faults-modal.json';
import faults from './faults.json';
import terms from './terms.json';
import buttons from './buttons.json';
import controllerSettings from './controller/settings.json';
import messages from './messages.json';
import commonText from './common-text.json';
import iot from './iot.json';
import form from './client/form.json';
import errors from './errors.json';
import cycleModals from './cycle/modals.json';
import cycleSettings from './cycle/settings.json';
import channelSettings from './channel/settings.json';
import reportModals from './report/modals.json';
import reportSteps from './report/steps.json';
import screenCommonText from './screen/common.json';
import noteCommonText from './note/common.json';
import memberModals from './member/modal.json';
import memberCommon from './member/common.json';
import contractModals from './contract/modal.json';
import contractCommon from './contract/common.json';

export const en = {
  translation: {
    labels,
    statuses,
    faults,
    terms,
    buttons,
    cycle: {
      modals: cycleModals,
      settings: cycleSettings,
    },
    member: {
      modals: memberModals,
      common: memberCommon,
    },
    contract: {
      modals: contractModals,
      common: contractCommon,
    },
    clients: {
      form,
    },
    channels: {
      faultsModal: chFaultsModal,
      settings: channelSettings,
    },
    thermocouples: {
      faultsModal: tcFaultsModal,
    },
    controllers: {
      settings: controllerSettings,
    },
    report: {
      modal: reportModals,
      steps: reportSteps,
    },
    screen: {
      commonText: screenCommonText,
    },
    note: {
      commonText: noteCommonText,
    },
    messages,
    commonText,
    iot,
    errors,
  },
};
